import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { getHomepageRedirectPath } from '../../utils/homepage';
import { MERCHANT_COMPANY_DOCUMENTS_PATH } from '../../utils/merchantNavigation';
import CustomerHome from './CustomerHome';
import MerchantHome from './MerchantHome';

const HomePage = () => {
  const {
    userType,
    merchantRole,
    merchantCompanyTypes,
    customerHasWarehouseEntry,
    isContractLocked,
    // Zorunlu onay kilidi: aşağıdaki evrak yönlendirmesinden ÖNCE gelmeli (bkz. not).
    isCustomerConsentLocked,
  } = useAuth();
  const redirectPath = getHomepageRedirectPath({
    userType,
    merchantRole,
    merchantCompanyTypes,
    customerHasWarehouseEntry,
  });

  if (redirectPath === null) return null;
  if (redirectPath) return <Navigate to={redirectPath} replace />;

  // Müşteri anasayfası: hero carousel + menü kısayolları.
  if (userType === 'customer') return <CustomerHome />;

  // Merchant: sözleşme/evrak kilidi varsa (menüde yalnız Şirket Bilgilerim kalır) doğrudan
  // evrak sekmesine götürülür; aksi halde iş ortağı anasayfası render edilir.
  if (userType === 'merchant') {
    // ÖNCE zorunlu onay kilidi. Onayların verildiği tek ekran (ConsentLockNotice)
    // MerchantHome içinde yaşıyor ve ProtectedRoute onay kilidindeyken /homepage DIŞINDAKİ
    // her rotayı /homepage'e geri gönderiyor. Aşağıdaki evrak yönlendirmesi bundan önce
    // çalışırsa /homepage → /my-warehouse-firm → /homepage sonsuz döngüsü oluşuyor ve
    // kullanıcı onay ekranını HİÇ göremeden kilitli kalıyordu (admin'in firmaya elle
    // eklediği merchant'lar tam olarak bu duruma düşüyor: onayları hiç vermemiş oluyorlar).
    if (isCustomerConsentLocked) return <MerchantHome />;

    if (isContractLocked && merchantRole === 'admin') {
      return <Navigate to={MERCHANT_COMPANY_DOCUMENTS_PATH} replace />;
    }
    return <MerchantHome />;
  }

  return (
    <div>
      <h2>Ana Sayfa</h2>
      <p>Bu, ana sayfa içeriğidir.</p>
    </div>
  );
};

export default HomePage;
